export default __webpack_public_path__ + "d666c05736217e5403c32fd303d3db9f.png";